import flow from 'lodash/flow';
import {
	ComponentWithAnalytics,
	withFireUiAnalytics,
} from '@atlassian/jira-analytics-web-react/src';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl';
import { connect } from '@atlassian/jira-react-redux';
import {
	baseUrlSelector,
	cloudNameSelector,
	isSiteAdminSelector,
} from '../../project-access-selector';

import type { State } from '../../project-access-types';

import DisabledAccessLevel from './view';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Props = Record<any, any>;

export default flow(
	injectIntl,
	ComponentWithAnalytics('link', {
		onUpgrade: 'clicked',
	}),
	withFireUiAnalytics({
		onUpgrade: 'projectAccessUpgrade',
	}),
	connect(
		(state: State) => ({
			baseUrl: baseUrlSelector(state),
			cloudName: cloudNameSelector(state),
			isSiteAdmin: isSiteAdminSelector(state),
		}),
		{},
	),
)(DisabledAccessLevel);
